import "../Css/groovePQR_pdf.css";
import Groove_pdf_headerPQR from "./Groove_pdf_headerPQR";
import PQR_Footer from "./PQR_Footer";

const Groove_pdf_page2PQR = ({
  pdf,
  PtewUrl,
  previewuser,
  previewapproved,
  showTensileTest = false,
  showGuidedBendTest = false,
  showOtherTest = false,
}) => {
  let isoverlay = pdf[0]?.wld_WPSType === "Groove" ? false : true;

  const width = "72.6%";


  const renderTableCell = (value) => value !== "" ? value : "--";

  function Guided_Bend() {
    const rows = [];
    for (let i = 0; i < pdf.length; i++) {
      const visualExamination = pdf[i]?.GuidedBend_Test || [];
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];
        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_rt_lft">{renderTableCell(item.PQR_GB_TypeofTest)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_GB_Thickness)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_GB_Width)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_GB_FormerMandrilDia)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_GB_AngleOfBend)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_GB_Acceptance_Criteria)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_GB_Results)}</td>
          </tr>
        );
      }
    }
    return rows;
  }
  function Guided_Bendoverlay() {
    const rows = [];
    for (let i = 0; i < pdf.length; i++) {
      const visualExamination = pdf[i]?.GuidedBend_Test_Overlay || [];
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];
        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_rt_lft">{renderTableCell(item.PQR_GBV_SpecimenNo)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_GBV_Thickness)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_GBV_BM_WeldOverlay)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_GBV_FormerDiam)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_GBV_BendAngle)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_GBV_Acceptance_Criteria)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_GBV_Remarks)}</td>
          </tr>
        );
      }
    }
    return rows;
  }

  function Toughness_Test() {
    const rows = [];
    for (let i = 0; i < pdf.length; i++) {
      const visualExamination = pdf[i]?.Toughness_Test || [];
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];
        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_rt_lft">{renderTableCell(item.PQR_TT_SpecimenNo)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_TT_WeldingProcess)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_TT_NotchLocation)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_TT_TestTemp)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_TT_ImpactValues)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_TT_Avg)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_TT_LateralExpansion)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_TT_Shear)}</td>
          </tr>
        );
      }
    }
    return rows;
  }
  function Tensile_Test() {
    const rows = [];
    for (let i = 0; i < pdf.length; i++) {
      const visualExamination = pdf[i]?.Tensile_Test || [];
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];
        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_rt_lft">{renderTableCell(item.PQR_Tensile_SpecimenNo)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_Tensile_Thickness)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_Tensile_Width)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_Tensile_Area)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_Tensile_UltimateLoad)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_Tensile_UltimateStress)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_Tensile_FailureLocation)}</td>
          </tr>
        );
      }
    }
    return rows;
  }

  function Other_Test() {
    const rows = [];
    for (let i = 0; i < pdf.length; i++) {
      const visualExamination = pdf[i]?.Other_Test || [];
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];
        rows.push(
          <tr key={`${i}-${j}`}>
            <td className="PQR_rt_lft">{renderTableCell(item.PQR_OT_TypeofTest)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_OT_Acceptance_Criteria)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_OT_Results)}</td>
            <td className="PQR_right">{renderTableCell(item.PQR_OT_Remarks)}</td>
          </tr>
        );
      }
    }
    return rows;
  }
  function Certification() {
    const rows = [];
    for (let i = 0; i < pdf.length; i++) {
      const visualExamination = pdf[i]?.Certification || [];
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];
        rows.push(
          <tr key={`${i}-${j}`} >
            <td className="PQR_rt_lft">
              {item.PQR_Certification_Welder_Name !== ""
                ? item.PQR_Certification_Welder_Name
                : "--"}
            </td>
            <td className="PQR_right">
              {item.PQR_Certification_ID !== ""
                ? item.PQR_Certification_ID
                : "--"}
            </td>
            <td className="PQR_right">
              {item.PQR_Certification_Process !== ""
                ? item.PQR_Certification_Process
                : "--"}
            </td>
          </tr>
        );
      }
    }
    return rows;
  }
  function CertificationLabRef() {
    const rows = [];
    for (let i = 0; i < pdf.length; i++) {
      const visualExamination = pdf[i]?.CertificationLabRef || [];
      for (let j = 0; j < visualExamination.length; j++) {
        const item = visualExamination[j];
        rows.push(
          <tr key={`${i}-${j}`} style={{ height: "14.2px" }}>
            <td className="PQR_Botmrt" colspan={2} style={{ borderLeft: "1px solid black", textAlign: "center" }}>
              {item.PQR_Certification_Lab_RefNo !== ""
                ? item.PQR_Certification_Lab_RefNo
                : "--"}
            </td>
          </tr>
        );
      }
    }
    return rows;
  }

  return (
    <div className="MainPDF" style={{ paddingTop: "15px", position: "relative" }}>
      <div id="container" className="flexb" >
        <div className="headerRow" >
          <Groove_pdf_headerPQR pdf={pdf} from="PQR"></Groove_pdf_headerPQR>
        </div>

        <div id="body" className="Content">


          {/* <!-- -----------------------------------------Table 1----------------------------------------------- --> */}
          {showTensileTest && !isoverlay ? (
            <>
              <div className="">
                <div className="PQRbasemetal">TENSILE TEST(QW-150)</div>
              </div>
              <table className="PQRTablePg2">
                <tr>
                  <th className="PQR_border">Specimen number</th>
                  <th className="PQR_noleft">
                    Thickness <br />
                    mm
                  </th>
                  <th className="PQR_noleft">
                    Width <br />
                    mm
                  </th>
                  <th className="PQR_noleft">
                    Area <br />
                    mm²
                  </th>
                  <th className="PQR_noleft">
                    Ultimate load <br />kN
                  </th>
                  <th className="PQR_noleft">
                    Ultimate stress <br />
                    MPa
                  </th>
                  <th className="PQR_noleft">Type of failure and location</th>
                </tr>

                {Tensile_Test()}
              </table>
              <table className="PQRTablePg2" >
                <tr>
                  <th className="PQR_border" style={{ width: "80px", textAlign: "left" }}>Remarks</th>
                  <td
                    colSpan=""
                    className="PQR_noleft"
                    style={{ textAlign: "left" }}
                  >
                    {pdf[0]?.PQR_Tensile_RemarksHorizontal}
                  </td>
                </tr>
                <tr>
                  <th className="PQR_noTop" style={{ width: "80px", textAlign: "left" }}>Report Number</th>
                  <td
                    colSpan=""
                    className="PQR_Botmrt"
                    style={{ textAlign: "left" }}
                  >
                    {pdf[0]?.PQR_Tensile_ReportNumHorizontal}
                  </td>
                </tr>
              </table>
            </>
          ) : showGuidedBendTest && isoverlay ? (
            <>
              <div className="group">
                <div className="PQRbasemetal" style={{ width: { width } }}>
                  GUIDED BEND TEST(QW-160)
                </div>
              </div>
              <table className="PQRTablePg2" style={{ width: { width } }}>
                <tr>
                  <th className="PQR_border" style={{ width: "30%" }}>
                    Nos. of specimen
                  </th>
                  <th className="PQR_noleft" style={{ width: "9%" }}>
                    Thk <br />(mm)
                  </th>
                  <th className="PQR_noleft" style={{ width: "15%" }}>
                    Breadth <br /> (mm)
                  </th>
                  <th className="PQR_noleft" style={{ width: "17%" }}>
                    Former Diameter <br />(mm)
                  </th>
                  <th className="PQR_noleft" style={{ width: "9%" }}>
                    Bend Angle <br />(deg)
                  </th>
                  <th className="PQR_noleft" style={{ width: "30%" }}>
                    Acceptance Criteria
                  </th>
                  <th className="PQR_noleft" style={{ width: "39%" }}>
                    Remark
                  </th>
                </tr>
                {Guided_Bendoverlay()}
              </table>
              <table className="PQRTablePg2" style={{ width: { width } }}>
                <tr style={{ width: "15%" }}>
                  <th className="PQR_border" style={{ width: "80px", textAlign: "left" }}>Remarks</th>
                  <td
                    colSpan=""
                    className="PQR_noleft"
                    style={{ textAlign: "left" }}
                  >
                    {pdf[0]?.PQR_GB_RemarksHorizontal}
                  </td>
                </tr>
                <tr style={{ width: "15%" }}>
                  <th className="PQR_noTop" style={{ width: "80px", textAlign: "left" }}>Report Number</th>
                  <td
                    colSpan=""
                    className="PQR_Botmrt"
                    style={{ textAlign: "left" }}
                  >
                    {pdf[0]?.PQR_GB_ReportNumHorizontal}
                  </td>
                </tr>
              </table>
            </>
          ) : null}

          {/* --------------------------------------------Table 2 --------------------------------------------------------------*/}
          {showGuidedBendTest && !isoverlay ? (
            <>
              <div className="group">
                <div className="PQRbasemetal">GUIDED BEND TEST(QW-160)</div>
              </div>
              <table className="PQRTablePg2">
                <tr>
                  <th className="PQR_border">Identification</th>
                  <th className="PQR_noleft">Thickness (mm)</th>
                  <th className="PQR_noleft">Width (mm)</th>
                  <th className="PQR_noleft">Former Mandril Dia (mm)</th>
                  <th className="PQR_noleft">Angle of Bend (°)</th>
                  <th className="PQR_noleft">Acceptance Criteria</th>
                  <th className="PQR_noleft">Results</th>
                </tr>
                {Guided_Bend()}
              </table>
              <table className="PQRTablePg2" style={{ width: { width } }}>
                <tr style={{ width: "15%" }}>
                  <th className="PQR_border" style={{ width: "80px", textAlign: "left" }}>Remarks</th>
                  <td
                    colSpan=""
                    className="PQR_noleft"
                    style={{ textAlign: "left" }}
                  >
                    {pdf[0]?.PQR_GB_RemarksHorizontal}
                  </td>
                </tr>
                <tr style={{ width: "15%" }}>
                  <th className="PQR_noTop" style={{ width: "80px", textAlign: "left" }}>Report Number</th>
                  <td
                    colSpan=""
                    className="PQR_Botmrt"
                    style={{ textAlign: "left" }}
                  >
                    {pdf[0]?.PQR_GB_ReportNumHorizontal}
                  </td>
                </tr>
              </table>
            </>
          ) : (
            ""
          )}

          {/* -----------------------------------------------------Table 3--------------------------------------------------------------- */}
          {!isoverlay ? (
            <>
              <div className="group">
                <div className="PQRbasemetal" style={{ width: { width } }}>
                  TOUGHNESS TEST(QW-170)
                </div>
              </div>
              <table className="PQRTablePg2" style={{ width: { width } }}>
                <tr>
                  <th className="PQR_border" colSpan="2" style={{ textAlign: "center" }}>Impact Test</th>
                  <th className="PQR_noleft" colSpan="2" style={{ textAlign: "center" }}>Charpy V Notch</th>
                  <th className="PQR_noleft" style={{ textAlign: "center" }}>Specimen Size in mm</th>
                  <th className="PQR_noleft" colSpan="3" style={{ textAlign: "center", backgroundColor: "white" }}>{pdf[0]?.PQR_TT_SpecimenSize_Dimension || ""}</th>
                </tr>
                <tr>
                  <th className="PQR_border" rowSpan="2" style={{ width: "18%", borderTop: "none" }}>Location of Specimen</th>
                  <th className="PQR_noleft" rowSpan="2" style={{ width: "10%", borderTop: "none" }}>Welding Process</th>
                  <th className="PQR_noleft" rowSpan="2" style={{ width: "10%", borderTop: "none" }}>Notch Location</th>
                  <th className="PQR_noleft" rowSpan="2" style={{ width: "10%", borderTop: "none" }}>Test Temp. °C</th>
                  <th className="PQR_noleft" colSpan="4" style={{ textAlign: "center", borderTop: "none" }}>Impact Values</th>
                </tr>
                <tr>
                  <th style={{ width: "10%", borderRight: "1px solid black", borderBottom: "1px solid black" }}>Impact Value (J)</th>
                  <th style={{ width: "8%", borderRight: "1px solid black", borderBottom: "1px solid black" }}>Avg. (J)</th>
                  <th style={{ width: "12%", borderRight: "1px solid black", borderBottom: "1px solid black" }}>Lateral Expansion (mm)</th>
                  <th style={{ width: "12%", borderRight: "1px solid black", borderBottom: "1px solid black" }}>% Shear Fracture</th>
                </tr>

                {Toughness_Test()}
              </table>
              <table className="PQRTablePg2" style={{ width: { width } }}>
                <tr>
                  <th className="PQR_border" style={{ width: "80px", textAlign: "left" }}>Remarks</th>
                  <td
                    colSpan=""
                    className="PQR_noleft"
                    style={{ textAlign: "left" }}
                  >
                    {pdf[0]?.PQR_TT_RemarksHorizontal}
                  </td>
                </tr>
                <tr>
                  <th className="PQR_noTop" style={{ width: "80px", textAlign: "left" }}>Report Number</th>
                  <td
                    colSpan=""
                    className="PQR_Botmrt"
                    style={{ textAlign: "left" }}
                  >
                    {pdf[0]?.PQR_TT_ReportNumHorizontal}
                  </td>
                </tr>
              </table>
            </>
          ) : (
            ""
          )}

          {/* --------------------------------------------Table 4-------------------------------------------------------- */}

          {/* --------------------------------------------Table 5-------------------------------------------------------- */}
          {showOtherTest ? (
            <>
              <div className="group">
                <div className="PQRbasemetal" style={{ width: { width } }}>
                  OTHER TEST
                </div>
              </div>
              <table className="PQRTablePg2" style={{ width: { width }, borderBottom: "1px solid black" }}>
                <tr>
                  <th className="PQR_border" style={{ width: "31.5%" }}>
                    Type of test
                  </th>
                  <th className="PQR_noleft" style={{ width: "18%" }}>
                    Acceptance criteria
                  </th>
                  <th className="PQR_noleft" style={{ width: "16.5%" }}>
                    Result
                  </th>
                  <th className="PQR_noleft" style={{ width: "34%" }}>
                    Remarks
                  </th>
                </tr>

                {Other_Test()}
              </table>
              {isoverlay && (
              <table className="PQRTablePg2" style={{ width: { width } }}>
                <tr>
                  <th className="PQR_border" style={{ width: "80px", textAlign: "left" }}>Remarks</th>
                  <td
                    colSpan=""
                    className="PQR_noleft"
                    style={{ textAlign: "left" }}
                  >
                    {pdf[0]?.PQR_OT_RemarksHorizontal}
                  </td>
                </tr>
                <tr>
                  <th className="PQR_noTop" style={{ width: "80px", textAlign: "left" }}>Report Number</th>
                  <td
                    colSpan=""
                    className="PQR_Botmrt"
                    style={{ textAlign: "left" }}
                  >
                    {pdf[0]?.PQR_OT_ReportNumHorizontal}
                  </td>
                </tr>
              </table>
              )}
            </>
          ) : null}
          {/* -----======================================================== */}
          <div className="group">
            <div className="PQRbasemetal" style={{ width: { width } }}>
              CERTIFICATION
            </div>
          </div>

          <div style={{ width: "100%", }}>
            {/* <div style={{ float: "left", width: "50%" }}> */}
            <table
              className="PQRTablePg2"
              style={{ width: "310px", float: "left", borderBottom: "1px solid black" }}
            >
              <tr style={{ borderBottom: "1px solid black" }}>
                <th className="PQR_border" style={{ width: "100px" }}>
                  Welders Name
                </th>
                <th className="PQR_noleft" style={{ width: "45px" }}>
                  Id
                </th>
                <th className="PQR_noleft" style={{ width: "60px" }}>
                  Process
                </th>
              </tr>

              {Certification()}
            </table>
            <table
              className="PQRCertificationTable"
              style={{ border: "1px solid black" }}
            >
              <tr>
                <th className="PQR_noleft" style={{ textAlign: "left", width: "20px", paddingLeft: "0px", borderLeft: "1px solid black" }}>
                  Tests conducted by
                </th>
                <td className="PQR_noleft" style={{ textAlign: "left", wordBreak: "break-word", width: "50px" }} >
                  {pdf[0]?.PQR_Certification_ConductedBy}

                </td>
              </tr>
              <tr>
                <th className="PQR_noleft" style={{ textAlign: "left", borderLeft: "1px solid black" }} colspan={2}>
                  Laboratory ref. number
                </th>
              </tr>
              {CertificationLabRef()}
            </table>
            {/* <br /> */}


            {pdf[4] ?
              <div id="footer" style={{ position: "fixed", top: "3000px" }}>
                <PQR_Footer
                  pdf={pdf}
                  previewuser={previewuser}
                  previewapproved={previewapproved}
                ></PQR_Footer>
              </div> :
              <div id="footer" style={{ position: "fixed", top: "1980px" }}>
                <PQR_Footer
                  pdf={pdf}
                  previewuser={previewuser}
                  previewapproved={previewapproved}
                ></PQR_Footer>
              </div>}
            {/* <!-- -------------------------------------------Table 3 --------------------------------------------------------------> */}
            {/* <br></br> */}
            {/* <br></br> */}
            <br></br>
          </div>
        </div>
        <div className="PQRcertifont">We certify that the statements in this record are correct and that the test welds were prepared, welded, and tested in accordance with the requirements of Section IX of the ASME Boiler and Pressure Vessel Code.
        </div>
        {pdf[4] ?
          <div id="footer" style={{ position: "fixed", top: "3080px" }}>
            <table className="WPSfooter">
              <tr>
                <td>Page 3 of 3</td>
              </tr>
            </table>
          </div> : <div id="footer" style={{ position: "fixed", top: "2055px" }}>
            <table className="WPSfooter">
              <tr>
                <td>Page 2 of 2</td>
              </tr>
            </table>
          </div>}
      </div>

    </div>
  );
};

export default Groove_pdf_page2PQR;
